import { render, staticRenderFns } from "./T1Rezerwacja.vue?vue&type=template&id=29a28da7&scoped=true&"
import script from "./T1Rezerwacja.vue?vue&type=script&lang=js&"
export * from "./T1Rezerwacja.vue?vue&type=script&lang=js&"
import style0 from "./T1Rezerwacja.vue?vue&type=style&index=0&id=29a28da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a28da7",
  null
  
)

export default component.exports